export default "__VITE_ASSET__9b0c8ed6__"